import { render, staticRenderFns } from "./DeliveryTimeTooltip.vue?vue&type=template&id=61f5f4d8&"
import script from "./DeliveryTimeTooltip.vue?vue&type=script&lang=js&"
export * from "./DeliveryTimeTooltip.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryTimeTooltip.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports